import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { Observable, tap } from 'rxjs';
import { LoadingIndicatorService } from '../../loading-indicator.service';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';

@Component({
  selector: 'casi-loading-indicator',
  standalone: true,
  imports: [
    FontAwesomeModule,
    AsyncPipe,
    NgIf,
    NgTemplateOutlet
  ],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent implements OnInit {

  loading$: Observable<boolean>;

  @Input()
  detectRouteTransition = false;

  @ContentChild("loading")
  customLoadingIndicator: TemplateRef<any> | null = null;

  constructor(
    private loadingService: LoadingIndicatorService,
    private router: Router,
    public faIcons: FaIconLibrary
  ) {
    faIcons.addIcons(...all);
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit(): void {
    if (this.detectRouteTransition) {
      this.router.events
        .pipe(
          tap((event) => {
            if (event instanceof RouteConfigLoadStart) {
              this.loadingService.loadingOn();
            } else if (event instanceof RouteConfigLoadEnd) {
              this.loadingService.loadingOff();
            }
          })
        )
        .subscribe();
    }
  }

}
